<template>
  <div>
    <drawer @toggleSidebar="toggleSidebar" :sidebar="sidebar" />
    <Header @toggleSidebar="toggleSidebar" />
    <!--====== POST LAYOUT 1 PART START ======-->

    <section v-loading="isLoading" class="post-layout-1-area pb-80">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="about-author-content">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/">首页</router-link>
                  </li>
                  <li v-if="article && article.channel" class="breadcrumb-item active" aria-current="page">
                    {{ String(article.channel) | channelToLabel }}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="post-layout-top-content" v-if="article && article.channel">
              <div
                class="
                  post-categories
                  d-flex
                  justify-content-between
                  align-content-center
                "
              >
                <div class="categories-item">
                  <span>{{ String(article.channel) | channelToLabel }}</span>
                </div>
                <div class="categories-share">
                  <ul>
                    <li><i class="fal fa-calendar"></i>{{ article.createdat ? formatTimestampToDateTime(article.createdat) : '' }}</li>
                    <li><i class="fas fa-eye" v-if="article.view"></i>{{ article.view }}</li>
                  </ul>
                </div>
              </div>
              <div class="post-content">
                <h3 class="title">
                  {{ article.title || '' }}
                </h3>
                <!--
                <p>
                  {{ article.summary || '' }}
                </p>
                -->
                <!--
                <div class="thumb">
                  <img :src="article.coverurl || ''" alt="" />
                </div>
                -->
              </div>
              
              <div class="post-text mt-30">
                <div v-if="article && (article.permission === null || (article.permission === 0 || token))">
                  <div v-html="processedMarkdownBody"></div>
                </div>

                <div v-else class="limited-content">
                  <div v-html="processedMarkdownBody"></div>
                  <div class="text-center mt-20 hide-article-box hide-article-pos">
                    <button 
                      class="btn-login"
                      type="button"
                      @click="goToRegister"
                    >
                      <svg style="margin-bottom: 3px;" t="1755249942293" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5391" width="16" height="16"><path d="M510.600002 576.000696c-52.199919 0.699999-94.599853 43.799932-94.599853 95.999851 0 31.299951 14.999977 59.199908 38.199941 76.69988 16.099975 12.199981 25.79996 31.099952 25.79996 51.299921v63.399901c0 17.799972 14.599977 32.899949 32.399949 32.59995 17.399973-0.2 31.599951-14.499977 31.599951-31.999951v-64.499899c0-20.099969 9.699985-38.69994 25.69996-50.799922C592.999874 731.200455 607.999851 703.300498 607.999851 672.000547c0-53.499917-43.699932-96.69985-97.399849-95.999851z m1.399998 127.999801c-17.599973 0-31.99995-14.399978-31.99995-31.99995s14.399978-31.99995 31.99995-31.999951 31.99995 14.399978 31.99995 31.999951-14.399978 31.99995-31.99995 31.99995z" p-id="5392" fill="#fc5531"></path><path d="M767.999603 376.001006V258.001189C767.999603 116.701409 652.399782-0.498409 511.000002 0.00159 370.10022 0.501589 256.000397 114.901412 256.000397 256.001192v119.999814c0 4.399993-3.599994 7.999988-7.999987 7.999988h-23.999963c-52.999918 0-95.999851 42.999933-95.999851 95.999851v447.999304c0 52.999918 42.999933 95.999851 95.999851 95.999851h575.999106c52.999918 0 95.999851-42.999933 95.999851-95.999851V480.000845c0-52.999918-42.999933-95.999851-95.999851-95.999851h-23.999963c-4.399993 0-7.999988-3.599994-7.999987-7.999988zM320.000298 256.001192c0-51.29992 19.999969-99.499846 56.199913-135.799789C412.500154 84.00146 460.70008 64.001491 512 64.001491s99.499846 19.999969 135.799789 56.199912C683.999733 156.501347 703.999702 204.701272 703.999702 256.001192v119.999814c0 4.399993-3.599994 7.999988-7.999988 7.999988H328.000286c-4.399993 0-7.999988-3.599994-7.999988-7.999988V256.001192z m479.999255 703.998907H224.000447c-17.699973 0-31.99995-14.299978-31.99995-31.99995V480.000845c0-17.699973 14.299978-31.99995 31.99995-31.999951h575.999106c17.699973 0 31.99995 14.299978 31.99995 31.999951v447.999304c0 17.699973-14.299978 31.99995-31.99995 31.99995z" p-id="5393" fill="#fc5531"></path></svg>
                      去注册，解锁文章
                    </button>
                  </div>
                </div>
              </div>
              <!--
              <div class="post-reader-text pt-50">
                <div class="row">
                  <div class="col-md-6">
                    <div class="post-reader-prev">
                      <span>上一篇</span>
                      <h4 class="title">
                        <a v-if="prevArticle" :href="`/posts/postOne/${prevArticle.id}`">{{ prevArticle.title }}</a>
                      </h4>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="post-reader-prev">
                      <span>下一篇</span>
                      <h4 class="title">
                        <a v-if="nextArticle" :href="`/posts/postOne/${nextArticle.id}`">{{ nextArticle.title }}</a>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            -->
            </div>
          </div>
          <div class="col-lg-4">
            <div class="qrcode-section">
              <div class="qrcode-container">
                <div v-if="currentUrl" ref="qrcodeContainer"></div>
                <div v-else>正在生成二维码...</div>
              </div>
              <div class="qrcode-text">
                <p class="qrcode-text-title">手机扫码</p>
                <div style="word-break: keep-all;">
                  分享更便捷
                </div>
                <div style="word-break: keep-all;">
                  第一时间收到最新动态
                </div>
              </div>
            </div>
            <style-one :datas="Posts" />
          </div>
        </div>
      </div>
    </section>

    <!--====== POST LAYOUT 1 PART ENDS ======-->

    <!--====== LATEST NEWS PART START ======-->

    <our-latest-news :Posts="Posts" />

    <!--====== LATEST NEWS PART ENDS ======-->

    <!--====== ADD PART ENDS ======-->


    <div class="add-area">
      <features />
    </div>

    <!--====== ADD PART ENDS ======-->

    <footer-one />
    <div class="go-top-area">
      <div class="go-top-wrap">
        <div class="go-top-btn-wrap">
          <a href="#" class="go-top go-top-btn d-block">
            <i class="fa fa-angle-double-up"></i>
            <i class="fa fa-angle-double-up"></i>
          </a>
        </div>
      </div>
    </div>


    <LoginRegisterDialog
      :visible="dialogVisible"
      :is-login="isLogin"
      @update:visible="(val) => dialogVisible = val"
      @loginSuccess="handleLoginSuccess"
    />


    <!--
    <el-dialog
      :title="isLogin ? '登录' : '注册'"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <template #title>
        <div class="dialog-header">
          <img src="@/assets/images/logo.png" alt="" style="width: 130px;" />
        </div>
      </template>
      <div v-if="isLogin">
        <el-form 
          :model="loginForm" 
          :rules="loginRules" 
          ref="loginForm" 
          label-position="left" 
          label-width="100px"
          aria-label="登录表单"
        >
          <el-form-item label="账号" prop="account">
            <el-input v-model="loginForm.account" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="loginForm.password" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
        </el-form>
        <div class="divider"></div>
        
      </div>

      <div v-if="!isLogin">
        <el-form 
          :model="registerForm" 
          :rules="registerRules" 
          ref="registerForm" 
          label-position="left" 
          label-width="100px"
          aria-label="注册表单"
        >
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="registerForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="图形验证码" prop="captcha" class="captcha-item">
            <el-input v-model="registerForm.captcha" placeholder="请输入图形验证码">
              <template #append>
                <div class="captcha-container">
                  <img 
                    :src="captchaurl" 
                    alt="图形验证码" 
                    @click="getCaptchaImage"
                    style="
                      cursor: pointer; 
                      height: 100%; 
                      max-width: 90px; 
                      object-fit: contain;
                      box-sizing: border-box;
                    "
                  >
                </div>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="短信验证码" prop="smsCode">
            <el-input v-model="registerForm.smsCode" placeholder="请输入短信验证码">
              <template #append>
                <el-button @click="sendSmsCode" :disabled="smsCodeDisabled" size="small">
                  {{ smsCodeText }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="姓名" prop="name">
            <el-input v-model="registerForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="公司" prop="company">
            <el-input v-model="registerForm.company" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="职务" prop="position">
            <el-input v-model="registerForm.position" placeholder="请输入职务"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="switchToLogin" v-if="!isLogin">返回登录</el-button>
        <div v-else class="no-account" @click="switchToRegister">没有账号？去注册</div>
        <div>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">
            {{ isLogin ? '登录' : '注册' }}
          </el-button>
        </div>
      </span>
    </el-dialog>
    -->
  </div>
</template>

<script>
import { getAds, clickPlacement } from '@/api/placement';
import config from '@/config';

import Header from "../../Utility/Header/index";
import StyleOne from "../../Utility/Sidebar/StyleOne.vue";
import FooterOne from "../../Utility/Footer/FooterOne.vue";
import OurLatestNews from "../../Utility/Common/OurLatestNews.vue";
import Drawer from "../../Mobile/Drawer.vue";
import LoginRegisterDialog from "@/components/Common/LoginRegisterDialog.vue";
import Features from "./Features.vue";


import { 
  getArticle,
  getArticleRichText
} from "@/api/article"; 
import { captchaImage } from "@/api/auth";
import { formatTimestampToDateTime } from '@/utils/dateUtil'; 
// 引入 markdown-it 库
import MarkdownIt from 'markdown-it';
import QRCode from 'qrcodejs2';

// 创建 markdown-it 实例，开启 html 选项
const md = new MarkdownIt({
  html: true, // 允许解析 HTML 标签
  linkify: true, // 自动识别 URL
  typographer: true // 启用一些智能引号和符号替换
});

export default {
  components: { 
    Header, 
    StyleOne, 
    FooterOne, 
    OurLatestNews, 
    Drawer,
    LoginRegisterDialog,
    Features
  },
  inject: ['dataWrapper', 'fetchStatus'],
  data: () => ({
    Posts: [],
    sidebar: false,
    article: null, 
    prevArticle: null, 
    nextArticle: null,
    markdownBody: '',
    processedMarkdownBody: '',
    captchaurl: '',
    captchaid: '',
    token: null,
    dialogVisible: false,
    isLogin: false,
    // 登录表单数据
    loginForm: {
      account: '',
      password: ''
    },
    // 登录表单验证规则
    loginRules: {
      account: [
        { required: true, message: '请输入账号', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' }
      ]
    },
    // 注册表单数据
    registerForm: {
      phone: '',
      captcha: '',
      smsCode: '',
      name: '',
      company: '',
      position: ''
    },
    // 注册表单验证规则
    registerRules: {
      phone: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
      ],
      captcha: [
        { required: true, message: '请输入图形验证码', trigger: 'blur' }
      ],
      smsCode: [
        { required: true, message: '请输入短信验证码', trigger: 'blur' }
      ],
      name: [
        { required: true, message: '请输入姓名', trigger: 'blur' }
      ],
      company: [
        { required: true, message: '请输入公司名称', trigger: 'blur' }
      ],
      position: [
        { required: true, message: '请输入职务', trigger: 'blur' }
      ]
    },
    smsCodeDisabled: false,
    smsCodeText: '获取短信验证码',
    smsCodeCountdown: 60,
    // 新增加载状态变量
    isLoading: true,
    currentUrl: window.location.href,
    BigCardsSettings: {
      slidesToShow: 1,
      slideToScroll: 1,
      autoplay: true,
      arrows: false
    },
    handlePrevClick() {
      this.isNavigable = false;
      this.$refs.BigCards.prev();
      setTimeout(() => {
        this.isNavigable = true;
      }, 100);
    },
    handleNextClick() {
      this.isNavigable = false;
      this.$refs.BigCards.next();
      setTimeout(() => {
        this.isNavigable = true;
      }, 100);
    },
    adsDetail: []
  }),
  created() {
    document.addEventListener("scroll", this.topToBottom);
    this.fetchArticleData();
    this.token = localStorage.getItem('token');
    this.fetchAdsDetail();
  },
  mounted() {
    // 在组件挂载后生成二维码
    if (this.currentUrl) {
      this.generateQRCode();
    }
  },
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          this.Posts = Array.isArray(this.dataWrapper.articles) 
            ? this.dataWrapper.articles.slice(0, 20) 
            : [];
        }
      },
      immediate: true,
      deep: true
    },
    currentUrl: {
      handler(newVal) {
        if (newVal) {
          this.generateQRCode();
        }
      },
      immediate: false
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
    topToBottom() {
      const result = document.querySelector(".go-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.classList.add("active");
      } else {
        result.classList.remove("active");
      }
    },
    async fetchArticleData() {
      const articleId = this.$route.params.id; 
      if (articleId) {
        try {
          const response = await getArticle(articleId);
          this.article = response.data; 

          this.prevArticle = response.prev;
          this.nextArticle = response.next;
          
          const markdownResponse = await getArticleRichText(articleId);
          if (markdownResponse.code === 200) {
            this.markdownBody = markdownResponse.data.body || '';
            this.processedMarkdownBody = md.render(this.markdownBody); 
          }
        } catch (error) {
          console.error('获取文章数据失败:', error);
        } finally {
          // 无论请求成功或失败，都结束加载状态
          this.isLoading = false;
        }
      }
    },
    formatTimestampToDateTime,
    goToRegister() {
      this.dialogVisible = true;
      this.isLogin = false;
      this.getCaptchaImage();
    },
    getCaptchaImage() {
      captchaImage().then((result) => {
        if (result.code == 201) {
          const res = result.data;
          this.captchaurl = res.captcha;
          this.captchaid  = res.captchaid;
          // 确保 DOM 更新
          this.$nextTick(() => {
            //console.log('Captcha URL updated:', this.captchaurl);
          });
        }
      });
    },
    refreshCaptcha() {
      this.captchaurl = `/api/captcha?t=${new Date().getTime()}`;
    },
    async sendSmsCode() {
      this.$refs.registerForm.validateField('phone', async (valid) => {
        if (valid) {
          try {
            await this.$axios.post('/api/sendSmsCode', {
              phone: this.registerForm.phone,
              captcha: this.registerForm.captcha
            });
            this.smsCodeDisabled = true;
            this.smsCodeText = `${this.smsCodeCountdown}s 后重试`;
            const timer = setInterval(() => {
              this.smsCodeCountdown--;
              this.smsCodeText = `${this.smsCodeCountdown}s 后重试`;
              if (this.smsCodeCountdown === 0) {
                clearInterval(timer);
                this.smsCodeDisabled = false;
                this.smsCodeText = '获取短信验证码';
                this.smsCodeCountdown = 60;
              }
            }, 1000);
          } catch (error) {
            console.error('发送短信验证码失败:', error);
            this.$message.error('发送短信验证码失败，请重试');
          }
        }
      });
    },
    // 切换到注册页面
    switchToRegister() {
      this.isLogin = false;
      // 清除登录表单的校验状态
      if (this.$refs.loginForm) {
        this.$refs.loginForm.clearValidate();
      }
      this.getCaptchaImage();
    },
    // 切换到登录页面
    switchToLogin() {
      this.isLogin = true;
      // 重置注册表单数据，避免残留
      this.registerForm = {
        phone: '',
        captcha: '',
        smsCode: '',
        name: '',
        company: '',
        position: ''
      };
      // 重置短信验证码状态
      this.smsCodeDisabled = false;
      this.smsCodeText = '获取短信验证码';
      this.smsCodeCountdown = 60;
      // 清除注册表单的校验状态
      if (this.$refs.registerForm) {
        this.$refs.registerForm.clearValidate();
      }
    },
    handleSubmit() {
      if (this.isLogin){
        this.submitLogin();
      } else {
        this.submitRegister();
      }
    },
    // 提交登录表单
    async submitLogin() {
      // 确保表单实例存在
      if (!this.$refs.loginForm) {
        console.error('登录表单实例未找到');
        return;
      }
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            const response = await this.$axios.post('/api/loginByAccount', this.loginForm);
            if (response.data.code === 200) {
              this.token = response.data.token;
              localStorage.setItem('token', this.token);
              this.dialogVisible = false;
              this.$message.success('登录成功');
            } else {
              this.$message.error(response.data.message || '登录失败，请重试');
            }
          } catch (error) {
            console.error('登录失败:', error);
            this.$message.error('登录失败，请重试');
          }
        }
      });
    },
    // 提交注册表单
    async submitRegister() {
      // 确保表单实例存在
      if (!this.$refs.registerForm) {
        console.error('注册表单实例未找到');
        return;
      }
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          try {
            const response = await this.$axios.post('/api/register', this.registerForm);
            if (response.data.code === 200) {
              this.token = response.data.token;
              localStorage.setItem('token', this.token);
              this.dialogVisible = false;
              this.$message.success('注册成功');
            } else {
              this.$message.error(response.data.message || '注册失败，请重试');
            }
          } catch (error) {
            console.error('注册失败:', error);
            this.$message.error('注册失败，请重试');
          }
        }
      });
    },
    generateQRCode() {
      // 清空之前的二维码
      if (this.$refs.qrcodeContainer) {
        this.$refs.qrcodeContainer.innerHTML = '';
        // 创建新的二维码实例
        new QRCode(this.$refs.qrcodeContainer, {
          text: this.currentUrl,
          width: 80,
          height: 80,
          colorDark : "#000000",
          colorLight : "#ffffff",
          correctLevel : QRCode.CorrectLevel.H
        });

        const logoImage = require('@/assets/images/logo_text.png');

        // 添加二维码中间的图片
        if (logoImage) {
          const logo = new Image();
          logo.crossOrigin = 'anonymous';
          logo.src = logoImage;

          logo.onload = () => {
            const qrImg = this.$refs.qrcodeContainer.querySelector('img');
            const canvas = this.$refs.qrcodeContainer.querySelector('canvas');

            if (canvas && qrImg) {
              canvas.style.display = 'inline-block';
              const ctx = canvas.getContext('2d');

              // 动态获取二维码尺寸
              const qrSize = Math.min(canvas.width, canvas.height);
              const padding = 4; // 设置内边距
              const logoSize = qrSize / 3.7 - 2 * padding; // 减去两倍内边距
              const bgSize = logoSize + 2 * padding; // 背景尺寸包含内边距
              const x = (qrSize - bgSize) / 2;
              const y = (qrSize - bgSize) / 2;
              const borderRadius = 8; // 设置圆角半径

              // 绘制带圆角的白色背景
              ctx.fillStyle = '#ffffff';
              ctx.beginPath();
              ctx.moveTo(x + borderRadius, y);
              ctx.lineTo(x + bgSize - borderRadius, y);
              ctx.quadraticCurveTo(x + bgSize, y, x + bgSize, y + borderRadius);
              ctx.lineTo(x + bgSize, y + bgSize - borderRadius);
              ctx.quadraticCurveTo(x + bgSize, y + bgSize, x + bgSize - borderRadius, y + bgSize);
              ctx.lineTo(x + borderRadius, y + bgSize);
              ctx.quadraticCurveTo(x, y + bgSize, x, y + bgSize - borderRadius);
              ctx.lineTo(x, y + borderRadius);
              ctx.quadraticCurveTo(x, y, x + borderRadius, y);
              ctx.closePath();
              ctx.fill();

              // 绘制 logo 到 canvas 中心，考虑内边距
              const logoX = x + padding;
              const logoY = y + padding;
              ctx.drawImage(logo, logoX, logoY, logoSize, logoSize);

              // 将 canvas 内容转换为数据 URL 并赋值给 img 元素
              qrImg.src = canvas.toDataURL();
              // 隐藏原始的 img 元素
              qrImg.style.display = 'none';
            }
          };

          logo.onerror = () => {
            console.error('Logo 图片加载失败，请检查图片路径和网络状态');
          };
        }
      }
    },
    async fetchAdsDetail(){
      try {
        const adsResponse = await getAds(config.AD_DETAILPAGEBOTTOMHORIZONTALROLLINGBANNER);
        this.adsDetail = adsResponse.data || {}; 
        console.log('this:adsDetail:',this.adsDetail);
        console.log
        this.isLoading = false;
      } catch (error) {
        // 添加错误处理
        console.log('画廊广告加载失败:', error);
        this.isLoading = false;
      }      
    },
    handleClick() {
      if (this.adsDetail && this.adsDetail.link && this.adsDetail.id) {
        const url = clickPlacement(this.adsDetail.id, this.adsDetail);
        window.open(url, '_blank');
      }
    }
  }
};
</script>

<style scoped>
.post-text {
  white-space: pre-wrap; /* 保留换行和空格 */
}
.limited-content {
  position: relative; /* 为阴影层提供定位参考 */
}
.limited-content > div {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
}

/* 阴影层样式 */
.shadow-overlay {
  position: absolute;
  /* 计算阴影层顶部位置，假设按钮距离内容底部有 20px 的 margin，每行高度 24px */
  bottom: calc(40px + 20px + 24px * 2); 
  left: 0;
  right: 0;
  /* 两行内容的高度，假设每行高度为 24px */
  height: 48px; 
  background: rgba(255, 255, 255, 0.8); /* 极浅的白色阴影 */
  pointer-events: none; /* 允许点击下面的内容 */
}

/* 自定义按钮样式 */
button {
  cursor: pointer;
}
.btn-login:hover {
  background-color: #ffeeeb;
}
.btn-login {
  display: inline-block;
  width: 167px;
  height: 40px;
  -webkit-box-shadow: 0 2px 4px 0 rgba(252, 85, 49, 0.2);
  box-shadow: 0 2px 4px 0 rgba(252, 85, 49, 0.2);
  border-radius: 20px;
  border: 1px solid #fc5531;
  font-size: 14px;
  font-weight: 500;
  color: #fc5531;
  line-height: 40px;
  text-align: center;
  position: relative;
}

div.hide-article-box {
  width: 100%;
  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0)), color-stop(70%, #fff));
  background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, #fff 70%);
  padding-bottom: 32px;
}
.hide-article-pos {
  position: relative;
  z-index: 996;
  padding-top: 160px;
  bottom: -1px;
  margin-top: -210px;
}

/* 去掉 append 插槽的灰色背景色 */
.el-input-group__append {
  background-color: transparent;
  border: none;
  padding: 0;
}

/* 确保验证码容器和图片布局正常 */
.captcha-container {
  height: 100%;
  display: flex;
  align-items: center;
}
:deep(.captcha-item .el-input-group__append){
  background: unset;
  border: unset;
}
:deep(.el-form-item){
  margin-bottom: 10px;
}
:deep(.el-form-item__error){
  line-height: 0;
  padding-top: 3px;
}

.el-form[aria-label="登录表单"] {
  /* 添加调试边框，确认表单范围 */
  border: 1px solid transparent; 
}

/* 注册表单样式 */
.el-form[aria-label="注册表单"] {
  /* 添加调试边框，确认表单范围 */
  border: 1px solid transparent; 
}
.dialog-footer{
  display: flex;
  justify-content: space-between;
}
.no-account{
  cursor: pointer;
}

/* 加载状态样式 */
.loading {
  text-align: center;
  padding: 20px;
  font-size: 18px;
  color: #666;
}
:deep(.el-loading-spinner){
  top: 30%;
}
.qrcode-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.1);
}

.qrcode-container {
  margin-right: 20px;
}

.qrcode-text {
  font-size: 14px;
  color: #333;
  margin-bottom: 0;
}
.qrcode-text-title{
  font-size: 18px;
  font-weight: bold;
}
</style>
